module.exports = __webpack_public_path__ + "static/img/searchBlank_mobile.83a486f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/searchBlank_mobile.svg
// module id = jCob
// module chunks = 1